import { Component } from '@angular/core';
import { CameraPreviewComponent } from './scanner/scanner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  imports: [CameraPreviewComponent],
})
export class AppComponent {
  title = 'mobile-scanner';

  ngOnInit(): void {}
}
